module.exports = __webpack_public_path__ + "img/1979359.webp";